/**
 * Statsig environment tier for gate/experiment targeting and metric filtering.
 * Override with VITE_STATSIG_TIER when hostname heuristics are not enough.
 */
export type StatsigEnvironmentTier = 'development' | 'testing' | 'production';

export function getStatsigEnvironmentTier(): StatsigEnvironmentTier {
    const override = import.meta.env.VITE_STATSIG_TIER?.toLowerCase();
    if (override === 'development' || override === 'testing' || override === 'production') {
        return override;
    }

    const host = window.location.hostname.toLowerCase();
    if (host === 'localhost' || host === '127.0.0.1') {
        return 'development';
    }
    // Shared test hosts (e.g. cobrakai.hd-test01.com) ship production builds.
    if (host.includes('hd-test')) {
        return 'testing';
    }
    return 'production';
}
